export enum ThemesEnum {
  LIGHT = 'light',
  Dark = 'dark',
}
